import * as angular from "angular";
import {IController} from "angular";

export class TimePickerComponent implements IController {
  form: any;
  timeStamp: any;
  min: any;
  max: any;
  name: string;
  ngPlaceholder?: string;
  onChange: Function;

  public time: any;

  constructor(private moment) {
  }

  $onInit() {
    this._setTime(this.timeStamp);

    if (!this.name) {
      this.name = 'time';
    }
  }

  $onChanges(changes) {
    if (changes.timeStamp && !changes.timeStamp.isFirstChange()) {
      this._setTime(this.timeStamp);
      this._checkValidity();
    }
    if ((changes.min && !changes.min.isFirstChange()) ||
      changes.max && !changes.max.isFirstChange()) {
      this._checkValidity();
    }
  }

  onTimeChange() {
    this.onChange({time: this.moment(this.time).valueOf()})
  }

  private _setTime(timeStamp) {
    this.time = timeStamp ? this.moment(timeStamp).toDate() : undefined
  }

  private _checkValidity() {
    if (this.min) {
      this.form[this.name].$setValidity("min", this.moment(this.time).valueOf() >= this.min);
    }
    if (this.max) {
      this.form[this.name].$setValidity("max", this.moment(this.time).valueOf() <= this.max);
    }
  }
}

angular
  .module('bringoz.admin.commons')
  .component('timePicker', {
    require: {
      form: '^form'
    },
    bindings: {
      timeStamp: '<?',
      min: '<?',
      max: '<?',
      name: '<?',
      ngPlaceholder: '@?',
      onChange: '&?'
    },
    template: require('./time-picker.html').default,
    controller: TimePickerComponent
  });
